import React from 'react';
import PropTypes from 'prop-types';

const Button = ({ className, secondary, ...props }) => (
  <div className="inline mr1">
    <button
      type="button"
      className={`button-${secondary ? 'secondary' : 'primary'} ${className}`}
      {...props}
    />
  </div>
);

Button.defaultProps = {
  className: '',
  secondary: false,
};

Button.propTypes = {
  className: PropTypes.string,
  secondary: PropTypes.bool,
};

export default Button;
